import styled from 'styled-components'
import { paperBackgroundCss } from './sharedStyles'

const Card = styled.div`
  ${paperBackgroundCss}
  display: flex;
  margin-bottom: 2rem;
  transition: box-shadow ease-in-out 0.4s;
  overflow: hidden;

  flex-wrap: wrap;

  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }
`

Card.Body = styled.div`
  padding: 1rem;

  flex: 1;
`

Card.Title = styled.h3`
  margin: 0;
  margin-bottom: 1rem;
`

Card.Text = styled.p`
  margin: 0;
  margin-bottom: 1rem;
`

Card.ImageWrapper = styled.div`
  position: relative;

  flex-basis: 100%;
  @media (min-width: 768px) {
    flex-basis: 50%;
  }
  @media (min-width: 1200px) {
    flex-basis: ${props => props.flexBasis || '50%'};
  }
`

Card.Image = styled.img`
  width: 100%;
  max-width: 100%;
  display: block;
  margin: 0;
`

Card.ImageCaption = styled.span`
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  position: absolute;
  right: 1rem;
  bottom: 1rem;
  color: #fafafa;
  line-height: 1;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 0.3rem 0.4rem;
  border-radius: 0.4rem;
`

export default Card
